// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#widget-container .text-box{
  border-radius: 4px;
  border: 1px solid var(--Neutral-Neutral-20, #ccc);
  background: var(--Neutral-White, #fff);
  box-shadow: 0px 12px 20px 0px rgba(117, 117, 117, 0.09);
  padding: 15px 24px;
  resize: none;
  width: 344px;
  box-sizing: border-box;
  height: 60px;
  color: var(--Text-Disabled, #b3b3b3);
  font-family: "McKinseySans-Regular", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
#widget-container .text-box:focus {
  color: #000;
}
`, "",{"version":3,"sources":["webpack://./src/components/input/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,sCAAsC;EACtC,uDAAuD;EACvD,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,oCAAoC;EACpC,+CAA+C;EAC/C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb","sourcesContent":["#widget-container .text-box{\n  border-radius: 4px;\n  border: 1px solid var(--Neutral-Neutral-20, #ccc);\n  background: var(--Neutral-White, #fff);\n  box-shadow: 0px 12px 20px 0px rgba(117, 117, 117, 0.09);\n  padding: 15px 24px;\n  resize: none;\n  width: 344px;\n  box-sizing: border-box;\n  height: 60px;\n  color: var(--Text-Disabled, #b3b3b3);\n  font-family: \"McKinseySans-Regular\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n#widget-container .text-box:focus {\n  color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
